import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getFinancialData } from '../../api/financialData/getFinancialData'

interface IArgs {
  partnerId: string
  fYear: number
  groupId: number | null
  forceFetch?: boolean
  eltType: EltType
  isRollup: number
}
export const getFinancialDataHelper = async ({
  partnerId,
  fYear,
  groupId,
  eltType,
  forceFetch,
  isRollup,
}: IArgs): Promise<IELTFinancialData | null> => {
  const res = await getFinancialData({
    eltType: eltType,
    pid: partnerId,
    fYear,
    groupId,
    forceFetch,
    isRollup,
  })
  if (!res) {
    return null
  }
  const parsedValues = Object.keys(res).reduce((acc, key) => {
    const value = res[key]
    const isJsonContainer =
      typeof value === 'string' &&
      (value.trimStart().startsWith('{') || value.trimStart().startsWith('['))
    return { ...acc, [key]: isJsonContainer ? parseJson(value) : value }
  }, {} as IELTFinancialData)

  return {
    ...parsedValues,
    SellToDesc: res.SellToDesc,
    SellThruDesc: res.SellThruDesc,
  }
}
